import React from 'react';
import {
  NamedLink,
  ExternalLink,
  LayoutComposer,
  Heading,
} from '../../../components';

import StaticPage from '../../PageBuilder/StaticPage';
import TopbarContainer from '../../TopbarContainer/TopbarContainer';
import FooterContainer from '../../FooterContainer/FooterContainer';
import css from '../BlogPages.module.css';

// import vegandessertlogo from '../../assets/vegandessertlogo.avif'
// import veganbaklawa from '../VeganDessertPage/images/veganbaklawa.avif'
// import vegancakes from '../VeganDessertPage/images/vegancakes.avif'
// import vegantoffee from '../VeganDessertPage/images/vegantoffee.avif'
// import veganmuffins from '../VeganDessertPage/images/veganmuffins.avif'
import blog1_1 from './assets/blog1_1.avif';
import blog1_2 from './assets/blog1_2.avif';
import blog1_3 from './assets/blog1_3.avif';

// import css from '../BlogMainPage.module.css';

const Blog1 = () => {
  const layoutAreas = `
    topbar
    main
    footer
  `;

  return (
    <StaticPage
      className={css.root}
      title="Dessert Delivery Near Me - Sweet Treats Nationwide | Sweet Tooth"
      schema={{
        '@context': 'http://schema.org',
        '@type': 'BlogPage',
        description: 'Sweet Tooth: Dessert delivery! From cakes to pastries, our menu caters to every Sweet Tooth. Enjoy gourmet treats delivered fresh!',
        name: 'Blog page 1',
      }}
    >
      <LayoutComposer areas={layoutAreas} className={css.layout}>
        {props => {
          const { Topbar, Main, Footer } = props;
          return (
          <>
            <Topbar as="header" className={css.topbar}>
                <TopbarContainer />
            </Topbar>
            <div className={css.heading}>
              <h2 style={{ textAlign:'center'}}>Welcome to Sweet Tooth's Gourmet Dessert Delivery – Your Go-To for Delectable Desserts, Right at Your Doorstep!</h2>
            </div>
            <div className={css.mainwrapper}>
              <div className="text-token-text-primary max-w-full overflow-x-hidden" data-testid="conversation-turn-21">
                <div className="px-4 py-2 justify-center text-base md:gap-6 m-auto">
                <div className="flex flex-1 text-base mx-auto gap-3 md:px-5 lg:px-1 xl:px-5 md:max-w-3xl lg:max-w-[40rem] xl:max-w-[48rem] group">
                <div className="relative flex w-full flex-col lg:w-[calc(100%-115px)] agent-turn">
                <div className="flex-col gap-1 md:gap-3">
                <div className="flex flex-grow flex-col max-w-full">
                <div className="min-h-[20px] text-message flex flex-col items-start gap-3 whitespace-pre-wrap break-words [.text-message+&amp;]:mt-5 overflow-x-auto" data-message-author-role="assistant" data-message-id="34b7589c-aff1-48b8-bee6-9a5a07d20786">
                <div className="markdown prose w-full break-words dark:prose-invert light">
                {/* <h1 style={{color:'black', textAlign:'left'}}>Welcome to Sweet Tooth's Gourmet Dessert Delivery – Your Go-To for Delectable Desserts, Right at Your Doorstep!</h1> */}
                <p>In a world bustling with the daily grind, there's nothing more delightful than savoring a sweet treat without stepping out. Here at Sweet Tooth, we get the importance of convenience, and that's why we've crafted a seamless delivery service, ensuring our scrumptious desserts reach you effortlessly. Join us as we take you on a journey through the sweetness of Sweet Tooth, making your experience both convenient and delicious.</p>
                <div style={{textAlign:'center'}}>
                <img loading="lazy" src={blog1_1} style={{height:'60vh'}} />
                </div>
                <h3>Experience the Sweetness of Effortless Dessert Indulgence</h3>
                <p>Delight in Every Bite, Wherever You Are</p>
                <p>Imagine having your favorite cupcakes, custom cakes, gourmet cookies, and artisan treats delivered right to your chosen location – be it home, work, or elsewhere. Sweet Tooth makes this dessert dream a reality because we believe everyone deserves the joy of our delectable desserts without the added stress. Our seamless platform offers services that are designed to bring you an array of baked delights, including custom cakes and gourmet cookies, all neatly packaged in gift boxes. Whether you're treating yourself or surprising a loved one, Sweet Tooth ensures a hassle-free and delightful experience, so you can savor every bite with the convenience you deserve.</p>
                <h2>Reliable and Timely Delivery</h2>
                <p>Your Desserts, On Your Schedule</p>
                <p>Our commitment to exceptional service extends to our delivery process. We understand the importance of timing, whether it's for events, celebrations, or satisfying sweet cravings. Sweet Tooth operates with precision and efficiency, ensuring your desserts arrive fresh, delicious, and right on time.</p>
                <div style={{ textAlign:'center'}}>
                <img loading="lazy" src={blog1_2} style={{width:'80%'}}/>
                </div>
                <h2>How to Place Your Delivery Order</h2>
                <p>Seamless and Exceptional Delivery</p>
                <p>Placing a delivery request with Sweet Tooth is straightforward and enjoyable. Here's how you can have our delightful desserts delivered to your doorstep:</p>
                <ol>
                <li>
                <p><strong>Visit Our Website:</strong> Head to our user-friendly website to explore our extensive listings and choose the desserts that tantalize your taste buds.</p>
                </li>
                <li>
                <p><strong>Customize Your Order:</strong> Tailor your request to your liking, selecting flavors, quantities, and any special requests you may have. You can also choose to message the bakery that has posted the specific listing you've selected to communicate with them what you are looking for!</p>
                </li>
                <li>
                <p><strong>Proceed to Checkout:</strong> Once you're satisfied with your selection, proceed to the checkout where you'll find our options.</p>
                </li>
                <li>
                <p><strong>Enter Delivery Details:</strong> Input your delivery address and any specific delivery instructions to ensure a seamless experience.</p>
                </li>
                <li>
                <p><strong>Choose Your Delivery Date and Time:</strong> Select the date and time that suits your schedule, giving you the flexibility to plan for that perfect moment of indulgence.</p>
                </li>
                <li>
                <p><strong>Confirm and Enjoy:</strong> Confirm checkout, sit back, and get ready to enjoy a hassle-free delivery experience. Your desserts will be on their way to you!</p>
                </li>
                </ol>
                <h3>Why Choose Sweet Tooth's Dessert Delivery – A Symphony of Reasons for Your Sweet Satisfaction!</h3>
                <p>Exceptional Service, Every Time</p>
                <ol>
                <li>
                <p><strong>Freshness Guarantee:</strong> Sweet Tooth's delivery services come with a freshness guarantee. We prioritize the quality of our desserts, ensuring they reach you as if they were just crafted in our kitchen.</p>
                </li>
                <li>
                <p><strong>Careful Handling:</strong> Our dedicated delivery team handles your desserts with the utmost care, making sure they arrive in pristine condition, ready to be enjoyed.</p>
                </li>
                <li>
                <p><strong>Wide Delivery Radius:</strong> Whether you're in the heart of the city or the outskirts, Sweet Tooth's delivery services cover a wide radius, ensuring that everyone can experience the joy of our desserts.</p>
                </li>
                </ol>
                <div style={{ textAlign:'center'}}>
                <div>
                <div>
                <img loading="lazy" src={blog1_3} style={{height:'40vh'}}/>
                </div>
                </div>
                </div>
                <div className="flex-1 overflow-hidden">
                <div className="react-scroll-to-bottom--css-pzapo-79elbk h-full">
                <div className="react-scroll-to-bottom--css-pzapo-1n7m0yu">
                <div className="flex flex-col pb-9 text-sm">
                <div className="w-full text-token-text-primary" data-testid="conversation-turn-87">
                <div className="px-4 py-2 justify-center text-base md:gap-6 m-auto">
                <div className="flex flex-1 text-base mx-auto gap-3 md:px-5 lg:px-1 xl:px-5 md:max-w-3xl lg:max-w-[40rem] xl:max-w-[48rem] group final-completion">
                <div className="relative flex w-full flex-col lg:w-[calc(100%-115px)] agent-turn">
                <div className="flex-col gap-1 md:gap-3">
                <div className="flex flex-grow flex-col max-w-full">
                <div className="min-h-[20px] text-message flex flex-col items-start gap-3 whitespace-pre-wrap break-words [.text-message+&amp;]:mt-5 overflow-x-auto" data-message-author-role="assistant" data-message-id="16d77bd1-93bb-4ca9-b199-037d96dd10a5">
                <div className="markdown prose w-full break-words dark:prose-invert light">
                <h3>Tips for an Enjoyable Dessert Delivery Experience – Unwrapping Sweet Delights with Ease and Joy!</h3>
                <p>Make the Most of Your Sweet Tooth Delivery</p>
                <ol>
                <li>
                <p><strong>Plan Ahead:</strong> Schedule your delivery well in advance to ensure your desserts arrive exactly when you want them.</p>
                </li>
                <li>
                <p><strong>Explore Our Menu:</strong> Take the time to explore our menu and discover new favorites with each delivery.</p>
                </li>
                <li>
                <p><strong>Surprise Loved Ones:</strong> Use our delivery services to surprise friends and family with a sweet treat on special occasions.</p>
                </li>
                </ol>
                <h2>Conclusion: Elevate Every Occasion with Sweet Tooth's Dessert Delivery Delights – From Birthdays to Baby Showers, a Symphony of Sweet Surprises!</h2>
                <p>Indulge in the unparalleled sweetness of Sweet Tooth's desserts, delivered with care to your doorstep. At Sweet Tooth, we believe that savoring our delectable creations should transcend beyond everyday moments. Our delivery services are a testament to our commitment to bringing happiness to your doorstep, ensuring every bite becomes a celebration.</p>
                <p>Whether celebrating a milestone, planning a special event, or simply treating yourself, Sweet Tooth's services are designed to make your dessert experience effortless and enjoyable. Elevate any occasion with our array of delightful options that cater to more than just casual snacking.</p>
                <p>Discover the convenience of Sweet Tooth's services, where you can effortlessly enjoy desserts for baby showers, birthdays, weddings, and more. Turn every moment into a sweet and memorable celebration, letting us be a part of your joyous occasions with our irresistible and carefully crafted creations.</p>
                <p>We are thrilled for you to experience the premium quality of our desserts through Sweet Tooth's delivery platform. Indulge in the unparalleled sweetness of our offerings, whether it's a birthday cake, bakery delight, or a vegan treat. Our commitment to excellence extends to every order, ensuring that each dessert is delivered with care and precision. Sweet Tooth is your go-to for elevating any occasion, from birthdays to baby showers and beyond. With a wide array of delightful options, we invite you to savor the joy in every bite. Thank you for choosing Sweet Tooth, where each dessert delivery is a celebration in itself. </p>
                </div>
                </div>
                </div>
                </div>
                </div>
                </div>
                </div>
                </div>
                </div>
                </div>
                </div>
                </div>
                </div>
                </div>
                </div>
                </div>
                </div>
                </div>
                </div>
                </div>
                <div className="w-full text-token-text-primary" data-testid="conversation-turn-22">
                <div className="px-4 py-2 justify-center text-base md:gap-6 m-auto">
                <div className="flex flex-1 text-base mx-auto gap-3 md:px-5 lg:px-1 xl:px-5 md:max-w-3xl lg:max-w-[40rem] xl:max-w-[48rem] group">
                <div className="flex-shrink-0 flex flex-col relative items-end">
                <div>
                <div className="pt-0.5">
                <div className="gizmo-shadow-stroke flex h-6 w-6 items-center justify-center overflow-hidden rounded-full"> </div>
                </div>
                </div>
                </div>
                </div>
                </div>
                </div>
            </div>

            <FooterContainer/>
          </>
        )}
        }
      </LayoutComposer>
    </StaticPage>
  );
};

export default Blog1;
